import {Component} from "@angular/core";
import {FormGroup} from "@angular/forms";
import {Organisation} from "../../job/shared/organisation.model";
import {User} from "../../shared/user/user.model";
import {Events, NavController} from "ionic-angular";
import {CountryCodesService} from "../../shared/country-codes.service";
import {LoginPage} from "../../login/login.page";
import {OrganisationValidator} from "../../signup/interpreter-signup/organisation.validator";
import {ProfileService} from "../profile.service";
import {ToastService} from "../../../app/core/toast.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-client-profile',
  templateUrl: 'client-profile.component.html',
  providers: [OrganisationValidator],

})
export class ClientProfileComponent {
  form: FormGroup;
  user: User = new User();
  invoiceEmailIsPersonalEmail: boolean = true;
  submitted: boolean = false;

  constructor(private organisationValidator: OrganisationValidator,
              private profileService: ProfileService,
              private nav: NavController,
              private toast: ToastService,
              private translate: TranslateService,
              private events: Events,
              public countryCodesService: CountryCodesService) {
    this.user.organisation = new Organisation();

    this.form = this.organisationValidator.init(this.user, 'update');
  }

  ngOnInit(): any {
    this.profileService.getProfile()
      .subscribe(profile => {
        this.user = profile;
        this.invoiceEmailIsPersonalEmail = !profile.organisation.invoice_email;
        this.organisationValidator.onOrganisationTypeValueChanges(this.user.organisation.type);
      });
    this.events.subscribe('profile_edit_form:submitted', () => this.save())
  }

  ngOnDestroy(){
    this.events.unsubscribe('profile_edit_form:submitted');
  }

  invoiceEmailToggled() {
    if (this.invoiceEmailIsPersonalEmail) {
      this.user.organisation.invoice_email = null;
    }
  }

  save() {
    this.submitted = true;
    if(!this.form.valid){
      return this.toast.show(this.translate.instant('global.form_invalid'));
    }

    this.profileService.updateProfile(this.user, 'organisation')
      .subscribe((res) => this.toast.show(res.message));
  }

  goToLoginPage() {
    this.nav.push(LoginPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/profile/client-profile/client-profile.component.ts